import './RedeemCoupon.scss';
import React from 'react';
import { getMonthlyForTier, getPlanByPriceId } from '../../shared/plans';

export default function RedeemCoupon({user, priceId}) {
  const coupon = user.coupon;
  const isFirstMonth = coupon.metadata?.period_applies_to === 'trial';

  const plan = getPlanByPriceId(priceId);
  const monthlyPlan = getMonthlyForTier(plan.tier);
  const ongoingPrice = monthlyPlan.unit_amount_in_cents / 100;
  const trialPrice = plan.unit_amount_in_cents / 100;

  const price = isFirstMonth ? trialPrice : ongoingPrice;
  const discountedPrice = coupon.percent_off
    ? Math.round(price * (1 - coupon.percent_off / 100))
    : (price - (coupon.amount_off / 100));
  const savings = price - discountedPrice;

  return (
    <div className='redeem-coupon'>
      <h1 className='redeem-coupon-heading'>You have a discount waiting!</h1>

      <div className='redeem-coupon-offer'>
        <div className='redeem-coupon-price-row'>
          <div className='redeem-coupon-ticket-icon'>
            <i className="fa-solid fa-ticket"></i>
          </div>
          <div className='redeem-coupon-price-details'>
            <div className='redeem-coupon-price-line'>
              <span className='redeem-coupon-price'>${discountedPrice}</span>
              {isFirstMonth
                ? <span className='redeem-coupon-original-price'>Normally ${trialPrice}</span>
                : <span className='redeem-coupon-period'>/month</span>
              }
            </div>
            <p className='redeem-coupon-price-subtitle'>
              {isFirstMonth ? 'for your first month' : `Usually $${ongoingPrice}/month`}
            </p>
          </div>
        </div>

        <div className='redeem-coupon-savings-badge'>
          <span className='redeem-coupon-savings-dot'></span>
          <span>Save ${savings} on your subscription today</span>
        </div>

        {isFirstMonth && (
          <p className='redeem-coupon-thereafter'>Then just ${ongoingPrice}/month after your first month</p>
        )}
      </div>

      <ul className='redeem-coupon-benefits'>
        <li><i className="fa-solid fa-check"></i>Unlimited searches</li>
        <li><i className="fa-solid fa-check"></i>Analyze unlimited domains</li>
        <li><i className="fa-solid fa-check"></i>Track rank of up to 1000 keywords</li>
      </ul>

      <button
        className='sales-modal-button'
        type='button'
        onClick={() => window.location.href = `${__ZUUL_URL}/sign-up/details?plan=${monthlyPlan.lookup_key}`}
      >Redeem your discount &nbsp;<i className='fa-solid fa-arrow-right'></i></button>

      <p className='redeem-coupon-disclaimer'>No commitment, cancel anytime</p>
    </div>
  );
}
